import { StyleFunctionProps } from "@chakra-ui/theme-tools";

export const styles = {
  global: (props: StyleFunctionProps) => ({
    "html, body": {
      fontSize: "16px",
    },
    "img": {
      display: "inline"
    }
  }),
}
